<template>
  <div class="space-y-3">
    <ShipmentSelect
      :form-data="formData"
      :is-edit-mode="isEditMode"
      @validate="validateForm"
    />

    <PromoDiscount
      :form-data="formData"
      @validate="validateForm"
    />
  </div>
</template>

<script>
import ShipmentSelect from './shipment/ShipmentSelect.vue'
import PromoDiscount from './shipment/PromoDiscount.vue'

export default {
  components: {
    ShipmentSelect,
    PromoDiscount,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        shipments: [],
        shipping_discount: 0,
        minimum_shipping_discount: 0,
        coverage_discount: [],
        payment_discount: 0,
      }),
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    formData: {
      handler() {
        this.validateForm()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validateForm() {
      const hasShipment = this.formData.shipments && this.formData.shipments.length > 0
      this.$emit('update:disable-next', !hasShipment)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
